import requestservice from "@/utils/request";
import Service from "@/utils/hyRequest";

//获取贵族信息
export function GetNobleList(params) {
  params["service"] = "Noble.GetLevelList";
  return requestservice({
    method: "post",
    params,
  });
}

//获取邀请信息
export function GetInviteList(params) {
  params["service"] = "Deputy.GetCode";
  return requestservice({
    method: "post",
    params,
  });
}

// 联系我们
export function sendMessage(data) {
  return Service({
    url: "v3/official-website/contact-us",
    method: "post",
    data,
  });
}
